import React from 'react';
import { NavLink } from "react-router-dom";

import hi from './images/lanabatyrova.png'
import highlight from './images/highlight.png'

import { Link } from "react-router-dom";


function LinkLi(to, text) {
  return <NavLink exact to={to} >{text}</NavLink>;
}

function Header() {

  return (
    <header>
      <NavLink exact to="/" className="logo">
        {/*<img src={hi}/>*/}
        {"LANA BATYROVA"}
        {/*<h1 className="name">Lana Batyrova</h1>*/}
        {/*<h2 className="subtitle">Character designer | Builds Artist | Animator</h2>*/}
      </NavLink>
      <nav>
        {LinkLi("/", "Home")}
        {LinkLi("/VisDev", "Portfolio")}
        {LinkLi("/demo-reel", "Reel")}

        {/* DROPDOWN */}
        <div className="dropdown">

          <NavLink to="/Sketches" className="nav-parent"> Projects</NavLink>

          <div className="dropdown-menu">
            <NavLink exact to="/ndawork" className="dropdown-primary">
              NDA Work
            </NavLink>
            <NavLink exact to="/illustration">
              Illustration
            </NavLink>
            <NavLink exact to="/Sketches">
              Sketches
            </NavLink>


          </div>
        </div>

        {LinkLi("/about", "About")}
        {LinkLi("/contact", "Contact")}
      </nav>
    </header>
  );
}

export default Header;



